"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "Group", {
    enumerable: true,
    get: function() {
        return Group;
    }
});
function Group(_) {
    /* istanbul ignore next */ return null;
}

//# sourceMappingURL=Group.js.map
